export default __webpack_public_path__ + "static/media/logo.497a6321.svg";